import { Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowLeft, Shield } from 'lucide-react';
import Footer from '../components/Footer';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-violet-950/30 to-slate-950 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        {/* Back button */}
        <Link to="/">
          <Button variant="ghost" className="mb-6 text-foreground/70 hover:text-foreground">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Grįžti į pradžią
          </Button>
        </Link>

        <Card className="bg-slate-900/50 border-primary/20 p-6 sm:p-8">
          {/* Header */}
          <div className="text-center mb-8">
            <Shield className="w-12 h-12 text-primary mx-auto mb-4" />
            <h1 className="text-3xl font-display font-bold text-foreground mb-2">
              Privatumo politika
            </h1>
            <p className="text-lg text-primary">NUMENAXIS – savęs pažinimo erdvė</p>
            <p className="text-sm text-muted-foreground mt-2">
              Paskutinį kartą atnaujinta: 2026-01-17
            </p>
          </div>

          {/* Introduction */}
          <div className="prose prose-invert max-w-none">
            <p className="text-foreground/90 leading-relaxed mb-6">
              NUMENAXIS gerbia jūsų privatumą ir sąmoningą santykį su savo asmenine informacija.
              Ši privatumo politika paaiškina, kokius duomenis renkame, kaip juos naudojame ir kaip juos saugome.
            </p>

            {/* Section 1 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-primary mb-4">1. Kokius duomenis renkame</h2>
              <p className="text-foreground/80 mb-3">
                Mes renkame tik minimalius duomenis, reikalingus platformos funkcionalumui ir asmeninei patirčiai užtikrinti:
              </p>
              <ul className="list-disc list-inside text-foreground/80 space-y-1 ml-4">
                <li>vardą,</li>
                <li>gimimo datą,</li>
                <li>pasirinktą pasisveikinimo formą (jei taikoma).</li>
              </ul>
              <p className="text-foreground/80 mt-3">
                Papildomai gali būti renkama minimali techninė informacija (pvz., įrenginio tipas ar naršyklės duomenys), tik tam, kad platforma veiktų stabiliai ir saugiai.
              </p>
            </section>

            {/* Section 2 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-primary mb-4">2. Kaip naudojami jūsų duomenys</h2>
              <p className="text-foreground/80 mb-3">Jūsų duomenys naudojami tik:</p>
              <ul className="list-disc list-inside text-foreground/80 space-y-1 ml-4">
                <li>individualių analizės rezultatų pateikimui,</li>
                <li>vartotojo patirties personalizavimui,</li>
                <li>platformos funkcionalumo užtikrinimui.</li>
              </ul>
              <p className="text-foreground/80 mt-4 mb-2">Duomenys:</p>
              <ul className="list-disc list-inside text-foreground/80 space-y-1 ml-4">
                <li>nenaudojami rinkodaros tikslais,</li>
                <li>neperduodami tretiesiems asmenims,</li>
                <li>nėra parduodami ar dalijami su išorinėmis organizacijomis.</li>
              </ul>
              <p className="text-foreground/80 mt-3">
                NUMENAXIS nerenka perteklinės informacijos ir nesiekia profiliuoti vartotojų.
              </p>
            </section>

            {/* Section 3 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-primary mb-4">3. Mokėjimai</h2>
              <p className="text-foreground/80 mb-3">
                Jei naudojatės mokamomis paslaugomis, mokėjimų informacija apdorojama per saugias trečiųjų šalių platformas (pvz., Stripe ar PayPal).
              </p>
              <p className="text-foreground/80">
                NUMENAXIS nekaupia ir nesaugo jūsų mokėjimo kortelių ar bankinių duomenų.
              </p>
            </section>

            {/* Section 4 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-primary mb-4">4. Duomenų saugojimas</h2>
              <p className="text-foreground/80 mb-3">
                Jūsų duomenys saugomi tik tiek, kiek tai būtina platformos veikimui ir paslaugų teikimui.
              </p>
              <p className="text-foreground/80 mb-3">
                Taikomos pagrįstos techninės ir organizacinės saugumo priemonės.
              </p>
              <p className="text-foreground/80">
                Jūs bet kada galite nutraukti naudojimąsi platforma ir paprašyti duomenų pašalinimo.
              </p>
            </section>

            {/* Section 5 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-primary mb-4">5. Privatumo politikos pakeitimai</h2>
              <p className="text-foreground/80 mb-3">
                Ši privatumo politika gali būti atnaujinama, plečiant ar tobulinant NUMENAXIS funkcionalumą.
              </p>
              <p className="text-foreground/80">
                Atnaujinta versija įsigalioja nuo jos paskelbimo platformoje dienos.
              </p>
            </section>

            {/* Section 6 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-primary mb-4">6. Baigiamosios nuostatos</h2>
              <p className="text-foreground/80 mb-3">
                Naudodamiesi NUMENAXIS, jūs patvirtinate, kad susipažinote su šia privatumo politika ir naudojatės platforma sąmoningai.
              </p>
              <p className="text-foreground/80">
                NUMENAXIS sukurta kaip saugi erdvė savistabai ir tyrinėjimui, gerbiant jūsų privatumą.
              </p>
            </section>
          </div>

        </Card>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}
